export function convertToNumber(value: string): number {
  return parseFloat(value.replace(',', '.'));
}
